import { isJobRequestField, isSiteRequestField } from "@/utils/formSelectionOptions";

export type BeLinkCompanyJobs = {
  beSourceCompanyTestTypeId?: number | null;
  beSourceRequiresAdditionalProctorFields?: boolean;
};

type RequestFieldLike = {
  fieldElementName?: string;
  fieldId?: number;
};

/** True when the building-plus click should open the request modal. */
export function beLinkOpensRequestModal(companyJobs: BeLinkCompanyJobs | null | undefined): boolean {
  const cttId = Number(companyJobs?.beSourceCompanyTestTypeId);
  return Boolean(companyJobs?.beSourceRequiresAdditionalProctorFields) && cttId > 0;
}

/**
 * Site and job are already chosen from the site row. Drop those fields, and Position,
 * which the link stores as the job name.
 */
export function omitBeLinkCoveredFields<T extends RequestFieldLike>(
  fields: T[] | null | undefined,
  lockedSiteId?: number | null,
  lockedJobId?: number | null
): T[] {
  const list = fields ?? [];
  const siteLocked = Number(lockedSiteId) > 0;
  const jobLocked = Number(lockedJobId) > 0;
  if (!siteLocked && !jobLocked) {
    return list;
  }

  return list.filter((field) => {
    if (siteLocked && isSiteRequestField(field)) {
      return false;
    }
    if (jobLocked && (isJobRequestField(field) || field.fieldElementName === "Position")) {
      return false;
    }
    return true;
  });
}
